import React from 'react';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import 'AppSrc/core/style/components/tables/vf-table.css';
import { ChevronFilledDown, ChevronFilledUp } from 'AppSrc/core/components/common/svg-icons';
import PropTypes from 'prop-types';
import { listTableColumnPropShape, listTableRowPropShape } from './table-proptypes';
import { DuplicateRowMenu } from './duplicate-row-menu';


const ListTableColumnHead = ({
  column,
  sortedColumn,
  sortDesc,
  setSortColumn,
}) => {
  const {
    id,
    name,
    sortable,
  } = column;
  if (!sortable) {
    return (
      <div className="head-text">
        {name}
      </div>
    );
  }
  const isSorted = id === sortedColumn;
  const icon = isSorted && sortDesc ? <ChevronFilledUp /> : <ChevronFilledDown />;
  return (
    <>
      <OptionButton
        className="head-text"
        onClick={setSortColumn}
        option={id}
      >
        {name}
      </OptionButton>
      <div className={`sort-indicator${isSorted ? ' sorted' : ''}`}>
        {icon}
      </div>
    </>
  );
};

const sortProps = {
  setSortColumn: PropTypes.func,
  sortedColumn: PropTypes.string,
  sortDesc: PropTypes.bool,
};

ListTableColumnHead.propTypes = {
  ...sortProps,
  column: listTableColumnPropShape,
};



const ListTable = ({
  columns,
  rows,
  onClickRow,
  className,
  setSortColumn,
  sortedColumn,
  sortDesc,
  noResultsMessage,
  isDuplicate,
}) => (
  <div className={`vf-table ${className}`}>
    <div className="vf-table-head-container">
      <div className="vf-table-head">
        {columns.map((column) => (
          <div
            className={`head-item column-${column.id}`}
            key={column.id}
          >
            <ListTableColumnHead
              column={column}
              sortedColumn={sortedColumn}
              sortDesc={sortDesc}
              setSortColumn={setSortColumn}
            />
          </div>
        ))}
      </div>
    </div>
    <div className="vf-table-body">
      {
        rows.map(({ id, cells, key }, index) => (
          <div
            className="vf-table-row-container"
            // if an explicit key is set in the row data use that
            key={key ? key : id}
          >
            <div className="vf-table-row">
              <OptionButton
                className="row-button"
                onClick={(option) => onClickRow && onClickRow(id)}
                option={id}
              >
                {cells}
              </OptionButton>
              {
                isDuplicate && (
                  <DuplicateRowMenu
                    id={id}
                    index={index}
                    key={key}
                    rows={cells}
                  />
                )
              }
            </div>
          </div>
        ))
      }
      {
        rows.length === 0 && (
          <p className="vf-table-no-results">
            {noResultsMessage}
          </p>
        )
      }
    </div>
  </div>
);



ListTable.propTypes = {
  columns: PropTypes.arrayOf(listTableColumnPropShape),
  rows: PropTypes.arrayOf(listTableRowPropShape),
  onClickRow: PropTypes.func,
  className: PropTypes.string,
  isDuplicate: PropTypes.bool,
  noResultsMessage: PropTypes.string,
  ...sortProps,
};

export { ListTable };

